import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  output,
  inject,
} from '@angular/core';
import { TableComponent } from './table.component';
import { PaginationDto } from '@shared/dto';
import { AsyncPipe } from '@angular/common';
import { TableColumnFilterComponent } from './table-column-filter/table-column-filter.component';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { Angulartics2OnModule } from 'angulartics2';
import { TableFormatterPipe } from './table-formatter.pipe';

export const defaultItemsPerPage = 8;

@Component({
  selector: 'app-async-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TableColumnFilterComponent,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgxPaginationModule,
    Angulartics2OnModule,
    AsyncPipe,
    TableFormatterPipe,
  ],
})
export class AsyncTableComponent extends TableComponent {
  public readonly pageChange = output<PaginationDto>();

  // Not inherited: a subclass with its own @Component gets no inherited
  // factory, so the base constructor runs without its dependencies.

  public paginate(page: number) {
    this.pageChange.emit({
      pageNumber: page,
      pageSize: this.itemsPerPage,
    });
  }
}
